export default {
  names: {
    email: 'E-mail',
    password: 'Hasło',
    confirmPassword: 'Potwierdź hasło',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    newEmail: 'Nowy adres e-mail',
    confirmEmail: 'Potwierdź nowy adres e-mail',
    newPassword: 'Nowe hasło'
  }
}
